var React = require('react');

function Patient (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z","key":1})]);
}

Patient.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Patient;

Patient.default = Patient;



//////////////////
// WEBPACK FOOTER
// /home/winc/bitbucket/iol2/sandbox-manager-v3/node_modules/svg-react-loader/lib/loader.js?name=Patient!./src/assets/icons/baseline-fullscreen.svg
// module id = 704
// module chunks = 1